
define('modules/application/wizard/steps/zoneStep/complexZoneStep/intrusionDetectionZoneStep/zoneModel',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Classes
  "../zoneModel",
  "./zoneCollection"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneModel,
  ZoneCollection) {

  var intrusionDetectionZoneModel = ZoneModel.extend({

    addConstructors: function() {
      this.ZoneCollection = ZoneCollection;
    },

    initialize                                   : function()  {
      ZoneModel.prototype.initialize.apply(this);

      this.unbind("change:volumetricProtectionModel",        this.volumetricProtectionModelChangedEventHandler);
      this.bind("change:volumetricProtectionModel",          this.volumetricProtectionModelChangedEventHandler, this);

      this.unbind("change:perimetralProtectionModel",        this.perimetralProtectionModelChangedEventHandler);
      this.bind("change:perimetralProtectionModel",          this.perimetralProtectionModelChangedEventHandler, this);

      this.unbind("change:radioSensorsModel",                this.radioSensorsModelChangedEventHandler);
      this.bind("change:radioSensorsModel",                  this.radioSensorsModelChangedEventHandler,         this);

      this.bind("change:number",                             this.zoneNumberChangedEventHandler,                this);

      window.BticinoS4B.eventAggregator.bind("zoneValidityUpdate:request", this.updateZoneValidity,                           this);
    },

    isDuplicable                        : function() {
      var perimetralProtection = this.get("perimetralProtectionModel");
      return perimetralProtection.isDuplicable();
    },

    isRemovable                         : function() {
      var volumetricProtection = this.get("volumetricProtectionModel"),
          perimetralProtection = this.get("perimetralProtectionModel");

      return ( volumetricProtection.isRemovable() && perimetralProtection.isRemovable() );
    },

    zoneNumberChangedEventHandler       : function() {
      this.get("volumetricProtectionModel").zoneNumberChangedEventHandler(this.get("number"));
      this.get("perimetralProtectionModel").zoneNumberChangedEventHandler(this.get("number"));
    },

    volumetricProtectionModelChangedEventHandler : function()  {
      this.get("volumetricProtectionModel").unbind("item:added", this.updateZoneValidity);
      this.get("volumetricProtectionModel").bind("item:added",   this.updateZoneValidity, this);

      this.get("volumetricProtectionModel").unbind("item:removed", this.updateZoneValidity);
      this.get("volumetricProtectionModel").bind("item:removed",   this.updateZoneValidity, this);
    },

    perimetralProtectionModelChangedEventHandler : function()  {
      this.get("perimetralProtectionModel").unbind("item:added", this.updateZoneValidity);
      this.get("perimetralProtectionModel").bind("item:added",   this.updateZoneValidity, this);

      this.get("perimetralProtectionModel").unbind("item:removed", this.updateZoneValidity);
      this.get("perimetralProtectionModel").bind("item:removed",   this.updateZoneValidity, this);
    },

    radioSensorsModelChangedEventHandler : function()  {
      this.get("radioSensorsModel").unbind("item:added", this.updateZoneValidity);
      this.get("radioSensorsModel").bind("item:added",   this.updateZoneValidity, this);

      this.get("radioSensorsModel").unbind("item:removed", this.updateZoneValidity);
      this.get("radioSensorsModel").bind("item:removed",   this.updateZoneValidity, this);
    },

    updateZoneValidity                 : function()  {
      var volumetricProtectionModel = this.get("volumetricProtectionModel");
      var perimetralProtectionModel = this.get("perimetralProtectionModel");
      var radioSensorsModel         = this.get("radioSensorsModel");
      var zoneValid                 = false;
      if ((volumetricProtectionModel)&&(volumetricProtectionModel.attributes)&&(volumetricProtectionModel.get("collection"))&&(volumetricProtectionModel.get("collection").models.length>0))
        zoneValid = true;
      else if ((perimetralProtectionModel)&&(perimetralProtectionModel.attributes)&&(perimetralProtectionModel.get("collection"))&&(perimetralProtectionModel.get("collection").models.length>0))
        zoneValid = true;
      else if ((radioSensorsModel)&&(radioSensorsModel.attributes)&&(radioSensorsModel.get("collection"))&&(radioSensorsModel.get("collection").models.length>0))
        zoneValid = true;

      this.set("valid", zoneValid);

      if (zoneValid)
        this.trigger("zone:valid");
      else
        this.trigger("zone:invalid");
      this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
    },

    deliverCurrent : function() {
      if ((this.get("volumetricProtectionModel")) && this.get("volumetricProtectionModel").deliverCurrent) this.get("volumetricProtectionModel").deliverCurrent();
      if ((this.get("perimetralProtectionModel")) && this.get("perimetralProtectionModel").deliverCurrent) this.get("perimetralProtectionModel").deliverCurrent();
      if ((this.get("radioSensorsModel")) && (this.get("radioSensorsModel").deliverCurrent))               this.get("radioSensorsModel").deliverCurrent();
    }

  });

  // Required, return the module for AMD compliance
  return intrusionDetectionZoneModel;

});